<template>
    <div class="c-toppage" :style="'width:' + Width + 'px;'">
        <div class="c-toppage__header">
            <WaterTop :screenWidth="screenWidth"></WaterTop>
        </div>
        <div class="c-toppage__content" :style="'width:' + Width + 'px;'">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
    </div>
</template>

<script>
import WaterTop from './top/WaterTop.vue';

export default {
    components: {
        WaterTop,
    },
    data() {
        return {
            screenWidth: 0,
            Width: 1920,
            showTopType: true,
        };
    },
    watch: {
        screenWidth: {
            handler(val, oldVal) {
                this.screenWidth = val;
                this.Width = val < 1024 && val > 0 ? 1024 : val === 0 ? 1920 : val;
            },
            immediate: true,
        },
    },
    mounted() {
        // 是否自动刷新token
        window.shouldAutoRefreshToken = true;
        // 监听浏览器窗口宽度改变
        window.addEventListener(
            'resize',
            () => {
                this.screenWidth = window.innerWidth;
                this.Width = this.screenWidth < 1024 ? 1024 : this.screenWidth;
            },
            true,
        );
        // 浏览器完成加载后获取窗口宽度
        // window.addEventListener('load', () => {
        this.screenWidth = window.innerWidth;
        this.Width = this.screenWidth < 1024 ? 1024 : this.screenWidth;
        // });
    },
    destroyed() {
        // 是否自动刷新token
        window.shouldAutoRefreshToken = false;
    },
    methods: {},
    // beforeRouteEnter(to, from, next) {
    //     next((vm) => {
    //         if (from.path.includes('scene')) {
    //             vm.showTopType = !vm.showTopType;
    //             console.log(5555555555);
    //         }else{

    //         }
    //         console.log(vm);
    //     });
    // },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

@include b(toppage, c) {
    position: relative;
    user-select: none;
    // width: 100vw;
    height: 100vh;
    background-color: hsl(238, 91%, 13%);

    @include e(header) {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 64px;
        z-index: 1;
        overflow: hidden;
    }
    @include e(content) {
        position: absolute;
        top: 64px;
        left: 0px;
        right: 0;
        height: calc(100% - 64px);
    }
}
</style>
